export default __webpack_public_path__ + "static/media/bee_logo_f4.75e467ee.svg";